import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { shouldShowCookieBanner, saveBannerLastShown, saveCookieConsent } from '../utils/cookieConsent';

const BannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #323232;
  color: white;
  padding: 20px;
  z-index: 9999;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
  display: ${props => props.$show ? 'flex' : 'none'};
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }
`;

const BannerText = styled.div`
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
  color: #ffffff;

  a {
    color: #ff6b35;
    text-decoration: underline;
    transition: color 0.3s ease;

    &:hover {
      color: #ff8c5a;
    }
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

const AcceptButton = styled.button`
  background: #ff6b35;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-family: var(--font-body, 'Segoe UI', sans-serif);

  &:hover {
    background: #ff8c5a;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 107, 53, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 20px;
    font-size: 14px;
  }
`;

const CookieBanner = ({ location }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Проверяем, нужно ли показывать плашку
    if (shouldShowCookieBanner()) {
      setShow(true);
      // Сохраняем дату показа
      saveBannerLastShown();
    }
  }, [location]);

  const handleAccept = () => {
    // Сохраняем согласие
    saveCookieConsent(true);
    // Скрываем плашку
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <BannerContainer $show={show}>
      <BannerText>
        Используем куки, чтобы сайт работал лучше. Оставаясь с нами, вы соглашаетесь на использование{' '}
        <Link to="/cookie-policy">файлов куки</Link>.
      </BannerText>
      <AcceptButton onClick={handleAccept}>
        ОК
      </AcceptButton>
    </BannerContainer>
  );
};

export default CookieBanner;
